import Box from '@material-ui/core/Box';
import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import { IconBuy, TypographyWrapper } from '..';
import { useShopConfigV2 } from '../../hooks/shopConfig';
import CustomIcon from '../CustomIcon/CustomIcon';

import css from './Empty.module.css';
import { CustomIconType, useCustomIcon } from '../../hooks/useCustomIcon';

interface EmptyProps {
  text?: string;
  button?: ReactNode;
  className?: string;
  icon?: ReactNode;
}

const Empty: FC<EmptyProps> = (props: EmptyProps) => {
  const { button, className, text, icon } = props;

  const emptyClassNames = classNames(css.empty, className);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p="20px"
      className={emptyClassNames}
    >
      {icon}
      {text && (
        <div className={css.emptyText}>
          <TypographyWrapper variant="body1">{text}</TypographyWrapper>
        </div>
      )}
      {button && <div className={css.emptyButton}>{button}</div>}
    </Box>
  );
};

export default Empty;
